import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlipBackward = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.13775 2.69526C5.3981 2.95561 5.3981 3.37772 5.13775 3.63807L3.60915 5.16667H10.9997C13.0247 5.16667 14.6663 6.80829 14.6663 8.83333C14.6663 10.8584 13.0247 12.5 10.9997 12.5H7.99967C7.63148 12.5 7.33301 12.2015 7.33301 11.8333C7.33301 11.4651 7.63148 11.1667 7.99967 11.1667H10.9997C12.2883 11.1667 13.333 10.122 13.333 8.83333C13.333 7.54467 12.2883 6.5 10.9997 6.5H3.60915L5.13775 8.0286C5.3981 8.28895 5.3981 8.71106 5.13775 8.9714C4.8774 9.23175 4.45529 9.23175 4.19494 8.9714L1.52827 6.30474C1.26792 6.04439 1.26792 5.62228 1.52827 5.36193L4.19494 2.69526C4.45529 2.43491 4.8774 2.43491 5.13775 2.69526Z",
		fill: "currentColor"
	})
});
export default SvgFlipBackward;
